import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import stringEn from './strings.en.json'
import stringKo from './strings.ko.json'

import LanguageDetector from 'i18next-browser-languagedetector'

const resources = {
    en: {
        translation: stringEn,
    },
    ko: {
        translation: stringKo,
    },
}

const options = {
    order: ['querystring', 'navigator'],
    lookupQuerystring: 'lng',
}

i18n.use(initReactI18next)
    .use(LanguageDetector)
    .init({
        resources: resources,
        // 초기 설정 언어
        //lng: 'en',
        fallbackLng: {
            ko: ['ko'],
            default: ['en'],
        },
        detection: options,
        //debug: true,
        defaultNS: 'translation',
        ns: 'translation',
        keySeparator: false,
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: false,
        },
    })

export default i18n
